jQuery(document).ready(function($) {
$('.collection-silder').slick({
centerMode:false,
centerPadding: '0px',
dots: false,
infinite: false,
speed: 500,
	slidesToShow: 5,
slidesToScroll: 1,
autoplay: false,
autoplaySpeed: 2000,
arrows: true,
  
responsive: [
  {
    breakpoint: 1050,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      arrows: false,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 600,
    settings: {      
	  centerPadding: '30px',
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 414,
    settings: {
      centerPadding: '30px',
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});
});

$(document).on('click', '.accordion-trigger', function(){
	var $this = $(this),
			$target = $this.closest('div').find('.accordion-content');
	if($this.hasClass('accordion-active')) {
		$this.removeClass('accordion-active');
		$target.slideUp();
	} else {
		$this.addClass('accordion-active');
		$target.slideDown();
	}
	return false;
});


$(document).ready(function(){
	if($('.product-slick-slider').length) {
		$('.product-slick-slider').slick({
			arrows:false,
			dots:false,
			asNavFor:'.product-thumb-slider'
		});
	}
	if($('.product-thumb-slider').length) {
		$('.product-thumb-slider').slick({
			arrows:false,
			dots:false,
			slidesToShow:5,
			vertical:true,
			verticalSwiping:true,
			loop:false,
			asNavFor:'.product-slick-slider',
			responsive:[
				{
					breakpoint:767,
					settings:{
						vertical:false,
						verticalSwiping:false
					}
				},
				{
					breakpoint:600,
					settings:{
						slidesToShow:4,
						vertical:false,
						verticalSwiping:false
					}
				}
			]
		});
	}
  var variantImage = $('.swatch-element input:checked').closest('.swatch-element').data('image'),
  imageIndex = $('.product-slick-slider .slick-slide[data-image="' + variantImage + '"]').data('slick-index');
  if(imageIndex != undefined) {
    $('.product-thumb-slider').slick('slickGoTo', imageIndex);
  }
	$('.product-thumb-slider div[data-slick-index]').click(function(e) {
		e.preventDefault();
		var slideno = $(this).data('slick-index');
		$('.product-thumb-slider').slick('slickGoTo', slideno);
	});




  
});

$(document).on('submit', '.collection-row .shopify-product-form, .topsillsection .shopify-product-form', function(e){
	e.preventDefault();
	$(e.target).find('input[type=image], input.submit-add-to-cart').attr('disabled', true).addClass('disabled');
	Shopify.addItemFromForm(e.target);
});

$(".category-filters-side").click(function(){
	$(this).toggleClass("show-filter-button");
});

$(window).on('load', function(){
	$(window).trigger('resize');
});



$(function() {
  $('.team_btn_wrapper .team_btn').click(function(){
    $(this).parent().parent().toggleClass(' active ');
    $(this).parent().parent().siblings().removeClass(' active '); 
    return false;
  });
});

jQuery(document).ready(function($) {
$('.main-slider').slick({
  centerMode:false,
  centerPadding: '0px',
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  arrows: true,
  responsive: [
  {
    breakpoint: 1024,
    settings: {
  centerMode:false,
  centerPadding: '0px',
      slidesToShow: 2,
      arrows: true,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 767,
    settings: {
  centerMode:false,
  centerPadding: '0px',
      slidesToShow: 1,
      arrows: true,
      slidesToScroll: 1,
    },
  }]
});
});

$(document).ready(function(){
    $('a[href^="#positions"]').on('click',function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': ($target.offset().top - 100)
        }, 900, 'swing', function () {
            // window.location.hash = target;
        });
    });
   
});
